
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import ToggleSwitch from "@/components/elements/ToggleSwitch.vue";

import AuthModule from "../../store/modules/auth";
import ReviewModule from "../../store/modules/review";

import {
  getReviewSyncSettingsLabels,
  hasPermission,
  STATE_SETTING_KEYS
} from "../../../../shared/typeUtils";
import { ReviewSyncSettings } from "../../../../shared/types";

@Component({
  components: {
    ToggleSwitch
  }
})
export default class ReviewSettingsModal extends Vue {
  private authModule = getModule(AuthModule, this.$store);
  private reviewModule = getModule(ReviewModule, this.$store);

  get userIsAuthor(): boolean {
    if (!this.reviewModule.reviewLoaded) {
      return false;
    }
    return (
      this.authModule.assertUser.username ===
      this.reviewModule.review.metadata.author
    );
  }

  get canModifyMetadata(): boolean {
    return this.reviewModule.viewState.userCanWrite || this.userIsAuthor;
  }

  get stateSettingKeys() {
    return STATE_SETTING_KEYS;
  }

  public getSettingValue(key: keyof ReviewSyncSettings): boolean {
    return this.reviewModule.resolvedReviewSyncSetting(key);
  }

  /**
   * Whether the toggle for a given setting should be disabled because the
   * installation is missing required GitHub App permissions. Permission
   * state is per-org (per-installation), not per-PR.
   */
  public isSettingDisabled(key: keyof ReviewSyncSettings): boolean {
    if (key !== "post_native_inline_comments") {
      return false;
    }
    const perms = this.reviewModule.org?.app_permissions;
    return (
      !hasPermission(perms, "contents", "write") ||
      !hasPermission(perms, "pull_requests", "write")
    );
  }

  public async onToggleSetting(key: keyof ReviewSyncSettings, val: boolean) {
    await this.reviewModule.updateReviewSyncSettings({
      [key]: val
    });
  }

  public getLabelForKey(key: keyof ReviewSyncSettings): string {
    return getReviewSyncSettingsLabels(key).title;
  }

  public getDescriptionForKey(key: keyof ReviewSyncSettings): string {
    return getReviewSyncSettingsLabels(key).description;
  }
}
